import React, { FC } from 'react';
import { MotifChip } from '@ey-xd/motif-react';

import './CustomTableHelpers.scss';
type RoleCellRendererProps = {
    data: any;
};
const RoleCellRenderer: FC<RoleCellRendererProps> = ({ data: { applicationRoles = [] } }) => {
    return (
        <div className="role-list">
            {applicationRoles.map((item: any, index: any) => (
                <MotifChip key={index} className="role-item">
                    {item.applicationRoleName}
                </MotifChip>
            ))}
        </div>
    );
};
export default RoleCellRenderer;
